import React, { useState, useEffect } from 'react';
import { logsApi } from '../../services/api';

function Bearbeitungslog({ targetType, targetId }) {
  const [logs, setLogs] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [hasLoaded, setHasLoaded] = useState(false);

  const fetchLogs = async () => {
    if (hasLoaded) return;
    setIsLoading(true);
    try {
      const params = {
        target_type: targetType,
        target_id: targetId,
        per_page: 100
      };
      const response = await logsApi.list(params);
      setLogs(response.data.logs);
      setHasLoaded(true);
    } catch (err) {
      setError('Fehler beim Laden der Bearbeitungslogs');
      console.error('Bearbeitungslog fetch error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isExpanded && !hasLoaded) {
      fetchLogs();
    }
  }, [isExpanded]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getActionLabel = (action) => {
    const labels = {
      'login': 'Anmeldung',
      'logout': 'Abmeldung',
      'activate_user': 'Benutzer verifiziert',
      'deactivate_user': 'Verifizierung entfernt',
      'suspend_user': 'Benutzer gesperrt',
      'unsuspend_user': 'Sperre aufgehoben',
      'delete_user': 'Benutzer geloescht',
      'update_user': 'Benutzer aktualisiert',
      'reset_password': 'Passwort zurueckgesetzt',
      'resend_verification': 'Verifizierungs-E-Mail gesendet',
      'send_otp': 'OTP-E-Mail gesendet',
      'set_otp': 'OTP manuell gesetzt',
      'delete_post': 'Beitrag geloescht',
      'delete_object': 'Objekt geloescht',
      'restore_post': 'Beitrag wiederhergestellt',
      'delete_comment': 'Kommentar geloescht',
      'restore_comment': 'Kommentar wiederhergestellt',
      'resolve_post_report': 'Post-Report bearbeitet',
      'resolve_comment_report': 'Kommentar-Report bearbeitet',
      'create_announcement': 'Ankuendigung erstellt',
      'update_announcement': 'Ankuendigung aktualisiert',
      'delete_announcement': 'Ankuendigung geloescht',
    };
    return labels[action] || action;
  };

  const getComments = (log) => {
    if (!log.details) return '-';
    
    // Extract reason or other relevant info from details
    if (log.details.reason) {
      return log.details.reason;
    }
    if (log.details.days) {
      return `${log.details.days} Tage`;
    }
    if (log.details.note) {
      return log.details.note;
    }
    if (log.details.action) {
      return log.details.action;
    }
    
    // For other details, show as JSON
    const keys = Object.keys(log.details);
    if (keys.length === 0) return '-';
    
    return keys.map(k => `${k}: ${log.details[k]}`).join(', ');
  };

  return (
    <section className="detail-section">
      <div 
        className="section-header collapsible"
        onClick={() => setIsExpanded(!isExpanded)}
        style={{ cursor: 'pointer' }}
      >
        <h2>
          <span className="expand-icon">{isExpanded ? '▼' : '▶'}</span>
          {' '}Bearbeitungslog
        </h2>
        <span className="activities-count">
          {hasLoaded ? `${logs.length} Eintraege` : ''}
        </span>
      </div>

      {isExpanded && (
        <div className="collapsible-content">
          {error && <div className="error-message">{error}</div>}
          
          {isLoading ? (
            <div className="loading-container" style={{ padding: '20px' }}>
              <div className="loading-spinner"></div>
            </div>
          ) : (
            <div className="table-container">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Aufgabe</th>
                    <th>Ausgefuehrt von</th>
                    <th>Zeitpunkt</th>
                    <th>Kommentare</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="empty-table-message">
                        Keine Bearbeitungslogs vorhanden
                      </td>
                    </tr>
                  ) : (
                    logs.map((log) => (
                      <tr key={log.id}>
                        <td>
                          <span className="action-badge">{getActionLabel(log.action)}</span>
                        </td>
                        <td>{log.admin_username}</td>
                        <td>{formatDate(log.created_at)}</td>
                        <td className="comments-cell">{getComments(log)}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </section>
  );
}

export default Bearbeitungslog;
